<template>
  <div id="app">
    <template v-if="!embed">
      <div class="hero">
        <h1>DevCoJobs</h1>
      </div>
    </template>

    <div class="jobs-wrapper">
      <!--  Job filter settings -->
      <div class="filters" v-if="false">
        <h2>Filters</h2>

        <!-- <div class="filter">
          <b class="title">Search</b>
          <input type="text" />
        </div> -->

        <filter-box
          name="Roles"
          :options="roles"
          :checkedOptions.sync="checkedRoles"
          :showAll.sync="showAllRoles"
        />

        <filter-box
          name="Regions"
          :options="regions"
          :checkedOptions.sync="checkedRegions"
          :showAll.sync="showAllRegions"
        />
      </div>

      <!-- List of filtered jobs -->
      <div style="max-width: 20rem;">
        <div class="jobs">
          <h2>Jobs</h2>
          <input type="text" v-model="filterText" placeholder="Search..." />
          <job-list :jobs="filteredJobs" :selectedJob.sync="selectedJob" />
          <p
            style="color:gray; font-size: smaller;padding:0.25rem;flex:1;text-align: bottom"
          >
            {{ filteredJobs.length }} jobs shown out of {{ jobs.length }} total
          </p>
        </div>

        <div class="add-company">
          <hr />
          <h3 style="margin-top: 1.5rem; margin-bottom: 0.4rem">
            Add a company
          </h3>
          <p style="font-size: small; margin-left: 0;margin-bottom:1.5rem;">
            Don't see jobs at your favorite developer tools company listed here?
            Let us know and we'll try and add it to the list.
          </p>
          <form
            name="add-company"
            method="post"
            id="addForm"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >
            <input type="hidden" name="form-name" value="add-company" />
            <p>
              <label>
                <span>Company</span><input type="text" name="name" />
              </label>
            </p>
            <p>
              <label>
                <span>Website</span><input type="text" name="website" />
              </label>
            </p>
            <p>
              <label>
                <span>Job Board</span>
                <select name="source[]" id="" v-model="board">
                  <option value="workable">Workable</option>
                  <option value="lever">Lever</option>
                  <option value="greenhouse">Greenhouse</option>
                  <option value="other">Other</option>
                </select>
              </label>
            </p>

            <p>
              <label v-if="board == 'other'">
                <span>Other</span><input type="text" name="other" />
              </label>
            </p>
            <div
              style="font-size:smaller; padding-left: 5.6rem;"
              v-if="board == 'other'"
            >
              <span>We're adding support for more job boards.</span><br />
              <span>Let us know which ones you want to see</span>
            </div>

            <p style="padding-left: 5.4rem;padding-top:0.5rem">
              <button
                type="submit"
                class="button"
                style="border: 1px solid blue;"
                @click.prevent="submitForm"
              >
                Submit
              </button>
              <span
                style="font-size: smaller;display:inline-block;padding-left:0.4rem"
                >{{ message }}</span
              >
            </p>
          </form>
        </div>
      </div>

      <!-- Currently selected job -->
      <job-view :job="selectedJob" />
    </div>

    <template v-if="!embed">
      <div class="footer" style="padding:8rem;">
        <a href="https://heavybit.com" style="text-decoration: none"
          >made with ❤️ by heavybit</a
        >
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import companies from "./companies.json";

import FilterBox from "./components/FilterBox.vue";
import JobList from "./components/JobList.vue";
import JobView from "./components/JobView.vue";

export default {
  name: "app",
  components: {
    FilterBox,
    JobList,
    JobView,
  },
  data() {
    return {
      embed: true,
      board: "",
      message: "",
      companies: companies,
      allJobs: [],
      roles: [
        {
          key: "eng",
          value: "Engineering",
          keywords: ["engineer", "developer", "architect"],
        },
        { key: "pro", value: "Product", keywords: ["product"] },
        { key: "gtm", value: "Marketing", keywords: ["marketer"] },
        { key: "sls", value: "Sales", keywords: ["sales", "representative"] },
        { key: "csm", value: "Support", keywords: ["support"] },
        { key: "ops", value: "Operations", keywords: [] },
      ],
      regions: [
        { key: "r_re", value: "Remote" },
        { key: "r_us", value: "USA" },
        { key: "r_ca", value: "Canada" },
        { key: "r_eu", value: "UK & Europe" },
        { key: "r_is", value: "Israel" },
        { key: "r_as", value: "Asia" },
        { key: "r_an", value: "Australia & NZ" },
        { key: "r_ro", value: "Rest of World" },
      ],
      showAllRoles: true,
      showAllRegions: true,
      showAllCompanies: true,
      checkedRoles: [],
      checkedCompanies: [],
      checkedRegions: [],
      selectedJob: null,
      checkedJobs: [],
      filterText: "",
    };
  },
  computed: {
    jobsByTitle() {
      let titles = {};
      this.filteredJobs.forEach((j) => {
        let t = j.normalizedTitle || "** Unknown Title **";
        if (!titles[t]?.jobs) titles[t] = { title: t, jobs: [] };
        titles[t].jobs.push(j);
      });
      return Object.values(titles);
    },
    titles() {
      return this.jobs.map((j) => j.normalizedTitle);
      // this.jobs.forEach((j) => roles.add(j.title || "Unknown title"));
      // let titles = [...roles].map((r) => {
      //   let t = r.replace(/front.*end/i, "Front-end");
      //   t = t.replace(/back.*end/i, "Back-end");
      //   t = t.replace(/Sr\. |Sr /, "Senior ");
      //   t = t.replace(/RVP/, "Regional VP");
      //   t = t.replace(/solution architect/i, "Solutions Architect");
      //   t = t.replace(/ \/ /, "/");
      //   t = t.replace(/EMEA|EU|UK|APJ|DACH|USA/, "");
      //   t = t.replace(/^Director,/i, "Director of");
      //   t = t.replace(/solution.* (\w*\b)/i, "Solutions $1");
      //   let array = t.split(/,| -|- |\(|\)/).filter(Boolean);
      //   return array.map((a) => a?.trim());
      // });
      // let sortedTitles = titles.flatMap((t) => t).sort();
      // let unique = [...new Set(sortedTitles)];
      // let titleRegex = new RegExp(
      //   /strategist|president|trainer|writer|developer\b|partner|consultant|lead|manager|engineer|executive|assistant|director|advocate|evangelist|designer|architect|recruiter|educator|rep|analyst|administrator|head|coordinator|co-ordinator|specialist|editor|associate|accountant/i
      // );

      // let filtered = unique.filter((u) => titleRegex.test(u));
      // return filtered;
    },
    keywords() {
      let words = new Set();
      this.checkedRoles.forEach((r) => {
        let role = this.roles.find((role) => role.key == r);
        let keywords = role.keywords || [];
        words.add(...keywords);
      });
      return [...words];
    },
    locations() {
      let locs = new Set();
      this.jobs.forEach((j) => locs.add(j.location || "Unknown Location"));
      let locations = [...locs];
      locations = locations.map((l) => l.replace(/USA?/, "United States"));
      locations = locations.map((l) => l.replace(/UK/, "United Kingdom"));
      // locations = locations.map((l) => l.replace(/remote/i, "REMOTE OK OK OK"));
      let regex = new RegExp(/remote/i);
      return locations.map((l) => ({
        location: l.trim(),
        remoteOK: regex.test(l),
      }));
      // return locations.map((l) =>
      //   l.split(/ ,?or | and |(,^,)/i).filter(Boolean)
      // );
    },
    jobs() {
      let jobs = [];
      let companies = Object.values(this.companies);
      companies.forEach((c) => (jobs = jobs.concat(c.jobs || [])));
      return jobs;
    },
    filteredJobs() {
      let jobs = [];
      jobs =
        this.checkedCompanies.length > 0
          ? this.jobs.filter((j) =>
              this.checkedCompanies.includes(j.company.slug)
            )
          : this.jobs;

      jobs =
        this.checkedRoles.length > 0
          ? jobs.filter((j) =>
              this.keywords.find((k) => j.title.toLowerCase().includes(k))
            )
          : jobs;
      jobs =
        this.filterText.length > 2
          ? jobs.filter(
              (j) =>
                j.title.toLowerCase().includes(this.filterText.toLowerCase()) ||
                j.company.company
                  .toLowerCase()
                  .includes(this.filterText.toLowerCase())
            )
          : jobs;

      return jobs.sort((a, b) => a.title.localeCompare(b.title));
    },
  },
  methods: {
    submitForm() {
      let myForm = document.getElementById("addForm");
      let formData = new FormData(myForm);
      let params = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      };
      console.log(formData);
      console.log(params.body);
      this.message = "";
      fetch("/", params)
        .then((response) => {
          console.log(response);
          if (response.status == 200 || response.status == 201) {
            this.message = "Succesfully submitted";
          } else {
            this.message = "Hmm, something's wrong.";
          }
        })
        .catch((error) => {
          this.message = "Oops, something went wrong.";
          console.log(error);
        });
    },
    stripNode(node) {
      node.children.forEach((child) => {
        if (child.hasChildren) this.stripNode(child);
        if (child.innerHTML == "&nbsp;" || child.innerHTML == "")
          node.removeChild(child);

        node.removeAttribute("style");
        node.removeAttribute("class");
        node.removeAttribute("id");
      });
    },
    fetchJobs() {
      let route = "api/v1/fetch-jobs";
      let names = Object.keys(this.companies).sort();
      names.map((name) => {
        axios
          .get(route, { params: { company: name } })
          .then((response) => {
            this.allJobs = this.jobs.concat(response.data.jobs);
            this.$set(this.companies[name], "jobs", response.data.jobs);
          })
          .catch((error) => console.log(error))
          .finally(() => {
            console.log(
              `Loaded ${this.companies[name].jobs?.length} ${name} jobs.`
            );
          });
      });
    },
  },
  mounted() {
    this.fetchJobs();
  },
};
</script>

<style>
/* * {
  border: 1px dashed lightcoral;
} */
#app {
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

#app > * {
  /* margin: 2rem auto; */
  margin: 0;
  margin-block-end: 0;
}

.jobs-wrapper {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 300;
  color: darkslategray;

  position: relative;
  /* margin: 2rem auto; */
  /* padding: 2rem 0rem; */
  /* width: 80%; */

  display: flex;
  align-items: flex-start;
  font-size: small;
}

.jobs-wrapper > * {
  margin-right: 1.5rem;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 0 1rem;
  padding-bottom: 1rem;
  min-height: 39rem;
}

.filters {
  display: flex;
  flex-direction: column;
  min-width: 11rem;
}

.jobs {
  width: 20rem;
  font-weight: 300;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
input,
select {
  font-size: large;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  color: darkslategray;
  border: 1px solid lightgray;
  border-radius: 5px;
}

.add-company p {
  margin: 0.25rem;
}

.add-company label span {
  font-weight: 500;
  display: inline-block;
  width: 5rem;
  text-align: left;
  padding-right: 0.3rem;
}

.add-company input,
.add-company select {
  font-size: small;
  padding: 0.4rem;
  padding-left: 0.5rem;
  width: 13rem;
  border-radius: 3px;
}
.add-company select {
  padding: 0.3rem;
  width: 8rem;
}

hr {
  border: 0;
  height: 1px;
  border-bottom: 1px solid lightgray;
}
</style>
